import script from "./AdminImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminImage.vue?vue&type=script&setup=true&lang=ts"

import "./AdminImage.vue?vue&type=style&index=0&id=3a67d828&lang=css"

const __exports__ = script;

export default __exports__